<template>
  <Loader v-if="loading" />
  <Card>
    <template v-slot:title>
      <h3>Statistiche Mensili</h3>
    </template>
    <template v-slot:content>
      <div class="charts-container">
        <div class="chart" hidden>
          <Chart type="bar"  :data="userChartData" :options="chartOptions" />
        </div>
        <div class="chart">
          <Chart type="bar"  :data="revenueChartData" :options="chartOptions" />
        </div>
        <div class="chart">
          <Chart type="bar"  :data="revenueChartDataPerPay" :options="chartOptions" />
        </div>
        <div class='chart'>
          <Chart type="bar" :data="revenueChartDataDaily" :options="chartOptions"/>
        </div>
        <div class="chart">
          <Chart type="bar"  :data="attendanceChartData" :options="chartOptions" />
        </div>
        <div v-for="chart in salesChartData" :key="chart.name" class="chart">
          <h3>{{ chart.name }}</h3>
          <Chart type="bar" :data="chart.chartData" :options="chartOptions" />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import Loader from "@/components/Loader.vue";
import Service from '@/services/levante-api/levante-api';
import moment from 'moment';


export default {
  components: {
    Loader,
  },
  setup() {
    const self = getCurrentInstance();
    const loading = ref(true);
    const userChartData = ref(null);
    const revenueChartData = ref(null);
    const revenueChartDataDaily = ref(null);
    const revenueChartDataPerPay = ref(null);
    const attendanceChartData = ref(null);
   // const salesChartData = ref(null);

    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: '',
        },
      },
    };

    const salesChartData = ref([]);
  
    const getRandomColor = () => {
      const r = Math.floor(Math.random() * 100+50);
      const g = Math.floor(Math.random() * 100+50);
      const b = Math.floor(Math.random() * 100+50);
      return `rgba(${r}, ${g}, ${b}, 0.2)`;
    };
    const transformDataByProduct = (data) => {
      const products = {}; // Oggetto per separare i dati per prodotto
      console.log(data);
      if (!Array.isArray(data)) {
        console.error("Non è un array:", data);
        return {};
      }
      data.forEach(item => {
        const month = moment(item.month, 'MM').format('MMM YYYY'); // Format month
        if (!products[item.nome]) {
          products[item.nome] = {
            name: item.nome,
            sales: [],
          };
        }
        products[item.nome].sales.push({ month:item.month, price: item.totale_vendite });
      });

      return products;
    };

    const loadSalesData = async () => {
      const salesResponse = await service.salesMonthly(); // Chiamata alla tua API

      const productsData = transformDataByProduct(salesResponse.items.data);

      // Genera un array di grafici per ogni prodotto
      salesChartData.value = Object.values(productsData).map(product => ({
        name: product.name,
        chartData: {
          labels: [...new Set(product.sales.map(sale => sale.month))], // Mesi unici
          datasets: [{
            label: `Vendite di ${product.name} in euro`,
            data: product.sales.map(sale => sale.price),
            backgroundColor: getRandomColor(),
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 1
          }]
        }
      }));
    };

    const transformDataByPaymentMethod = (data) => {
  const methods = {};

  data.forEach(item => {
    // Use both year and month from API
    const month = moment(`${item.anno}-${item.mese}`, 'YYYY-M').format('MMM YYYY');
    if (!methods[item.nome]) {
      methods[item.nome] = {
        label: item.nome,
        data: [],
        backgroundColor: getRandomColor(),
        borderColor: 'rgba(0, 0, 0, 1)',
        borderWidth: 1
      };
    }
    methods[item.nome].data.push({ month, importo: item.importo });
  });

  return methods;
};


    const fetchChartData = async () => {
      try {
        loading.value = true;

        const [userResponse, revenueResponse, revenueResponsePerPay, revenueResponseDaily,attendanceResponse, salesResponse] = await Promise.all([
          service.userMonthly(),
          service.paymentsMonthly(),
          service.paymentsMonthlyPerPay(),
          service.paymentsDaily(),
          service.attendancesMonthly(),
          loadSalesData(),
        ]);
     
        const months_revenueChartData = [...Array(revenueResponse.items.data.length)].map((_, i) => moment().subtract(i, 'months').format('MMM YYYY')).reverse();
        const months_attendanceChartData = [...Array(attendanceResponse.items.data.length)].map((_, i) => moment().subtract(i, 'months').format('MMM YYYY')).reverse();
        //const months_salesChartData = [...Array(attendanceResponse.items.data.length)].map((_, i) => moment().subtract(i, 'months').format('MMM YYYY')).reverse();
        const months_userChartData = [...Array(userResponse.items.data.length)].map((_, i) => moment().subtract(i, 'months').format('MMM YYYY')).reverse();

        userChartData.value = {
          labels: months_userChartData,
          datasets: [{
            label: 'Numero Persone',
            data: userResponse.items.data,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 1,
          }],
        };
        console.log(userResponse);
        console.log(userResponse.items.data);

        revenueChartData.value = {
          labels: months_revenueChartData,
          datasets: [{
            label: 'Incassi nei mesi',
            data: revenueResponse.items.data,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 1,
          }],
        };


        const days_revenueChartDataDaily = revenueResponseDaily.items.data.map(item => `Giorno ${item.giorno}`);

// Estrai gli importi per il dataset
const amounts_revenueChartDataDaily = revenueResponseDaily.items.data.map(item => item.importo);

// Configura i dati per il grafico
revenueChartDataDaily.value = {
  labels: days_revenueChartDataDaily, // Etichette con i giorni
  datasets: [{
    label: 'Incassi nel mese attuale per giorno',
    data: amounts_revenueChartDataDaily, // I dati degli importi
    backgroundColor: 'rgba(54, 162, 235, 0.2)',
    borderColor: 'rgba(0, 0, 0, 1)',
    borderWidth: 1,
  }]
};
     
        // Trasformare i dati per metodo di pagamento

// Genera sempre le etichette degli ultimi 12 mesi (come gli altri grafici)
const months_salesChartData = [...Array(12)].map((_, i) => moment().subtract(i, 'months').format('MMM YYYY')).reverse();

// Dati suddivisi per prodotto
const productsData = transformDataByPaymentMethod(revenueResponsePerPay.items.data);

// Creazione del grafico
revenueChartDataPerPay.value = {
  labels: months_salesChartData,
  datasets: Object.values(productsData).map(product => ({
    label: product.label,
    data: months_salesChartData.map(month => {
      const sale = product.data.find(d => d.month === month);
      return sale ? sale.importo : 0;
    }),
    backgroundColor: product.backgroundColor,
    borderColor: product.borderColor,
    borderWidth: product.borderWidth,
  }))
};

        attendanceChartData.value = {
          labels: months_attendanceChartData,
          datasets: [{
            label: 'Presenze',
            data: attendanceResponse.items.data,
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: 1,
          }],
        };

        /*salesChartData.value = {
          labels: months_salesChartData,
          datasets: [{
            label: 'Vendite',
            data: salesResponse.items.data,
            backgroundColor: 'rgba(153, 102, 255, 0.2)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1,
          }],
        };*/
      } catch (error) {
        console.error('Errore nel recupero dei dati per i grafici:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchChartData();
    });

    return {
      loading,
      userChartData,
      revenueChartData,
      revenueChartDataDaily,
      attendanceChartData,
      salesChartData,
      chartOptions,
      revenueChartDataPerPay
    };
  },
};
</script>

<style scoped>
.charts-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.chart {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
</style>
